/**
 * bannerImg.ts — Banner.imageSizes 가 있으면 srcset 으로, 없으면 imageUrl 폴백.
 *
 * 백엔드가 80/200/400/800/1600 webp 5종을 생성해 image_sizes 에 저장.
 * 구버전 (4종 thumb/small/medium/large) 도 호환 — 가능한 키만 srcset 에 포함.
 */

export interface BannerImgAttrs {
  src: string;
  srcSet?: string;
  sizes?: string;
}

export function bannerImgAttrs(
  imageUrl: string,
  imageSizes: Record<string, string> | null | undefined,
  ctxSizes: string,
  maxWidth?: number,  // srcset 의 최대 폭 제한 (예: 400 → 800w/1600w 제외). 미지정 = 전체.
): BannerImgAttrs {
  if (!imageSizes) return { src: imageUrl };
  const max = maxWidth ?? 1600;
  const parts: string[] = [];
  if (imageSizes.micro && 80 <= max) parts.push(`${imageSizes.micro} 80w`);
  if (imageSizes.thumb && 200 <= max) parts.push(`${imageSizes.thumb} 200w`);
  if (imageSizes.small && 400 <= max) parts.push(`${imageSizes.small} 400w`);
  if (imageSizes.medium && 800 <= max) parts.push(`${imageSizes.medium} 800w`);
  if (imageSizes.large && 1600 <= max) parts.push(`${imageSizes.large} 1600w`);
  if (parts.length === 0) return { src: imageUrl };
  return {
    src: imageSizes.small || imageSizes.medium || imageSizes.thumb || imageSizes.micro || imageUrl,
    srcSet: parts.join(", "),
    sizes: ctxSizes,
  };
}

/** 컨텍스트별 sizes — 화면 폭에 따른 표시 폭 hint */
export const CTX_SIZES = {
  // 메인 카드 그리드 (Standard): 모바일 2열 (50vw), 데스크탑 4열 (25vw)
  card: "(max-width: 640px) 50vw, 25vw",
  // 사이드바 썸네일: 50~100px 고정
  thumb: "120px",
  // 슬라이더 (VIP/PLATINUM/GOLD): 전체 폭의 80~100%
  slider: "(max-width: 640px) 90vw, 60vw",
  // 즐겨찾기 리스트: 모바일 100%, 데스크탑 30vw
  list: "(max-width: 640px) 100vw, 30vw",
  // 상세보기 풀사이즈
  detail: "100vw",
};
